<template>
  <VueTagsInput
    ref="input"
    v-model="search"
    :tags="tags"
    :autocomplete-min-length="0"
    :autocomplete-items="filteredLocations"
    :add-only-from-autocomplete="true"
    placeholder="Locations..."
    class="locations-tags-input"
    v-on="$listeners"
    @tags-changed="onTagsChanged"
  />
</template>

<script>
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import VueTagsInput from '@johmun/vue-tags-input'
import { matchesQuery } from '@/utils/autocompleteFilter'

@Component({
  components: {
    VueTagsInput
  },
  computed: {
    ...mapGetters(['currentMerchant', 'locations'])
  }
})
export default class MultiLocationSelect extends Vue {
  @Prop({ type: Array, default: () => [] }) value

  search = ''
  tags = []

  @Watch('value', { deep: true })
  onValueChange(val) {
    const ids = (val || [])
      .map(l => l?.id)
      .filter(Boolean)
      .sort()
    const currentIds = this.selectedIds.slice().sort()
    if (
      ids.length === currentIds.length &&
      ids.every((id, i) => id === currentIds[i])
    ) {
      return
    }
    if (val?.length && Array.isArray(val)) {
      this.setValue(val)
    } else if (!val?.length) {
      this.tags = []
    }
  }

  get selectedIds() {
    return this.tags.map(t => t.value?.id ?? t.id).filter(Boolean)
  }

  get filteredLocations() {
    const locations = this.locations || []
    const selected = this.selectedIds

    return locations
      .filter(loc => !selected.includes(loc.id))
      .map(loc => ({ text: loc.name, value: loc }))
      .filter(item => matchesQuery(this.search, item.text))
  }

  clear() {
    this.search = ''
    this.tags = []
    this.emitChange()
  }

  onTagsChanged(newTags) {
    this.tags = newTags
    this.emitChange()
  }

  emitChange() {
    const value = this.tags.map(t => t.value || t).filter(Boolean)
    this.$emit('change', value)
    this.$emit('input', value)
  }

  setValue(items) {
    if (!items?.length) {
      this.tags = []

      return
    }
    const locations = this.locations || []
    this.tags = items.map(loc => {
      const full = locations.find(l => l.id === (loc?.id ?? loc))
      const obj = full || loc

      return { text: obj.name, value: obj }
    })
  }
}
</script>

<style lang="scss" scoped>
.locations-tags-input {
  flex: 1;
  min-width: 0;
}
.locations-tags-input ::v-deep .ti-tag.ti-valid {
  &:not(.ti-deletion-mark) {
    background-color: $button-blue;
    border-color: $button-blue;
    color: #fff;
  }
}
.locations-tags-input ::v-deep .ti-autocomplete {
  max-height: 150px;
  background-color: #fff !important;
  border: 1px solid #ced4da;
  border-top: none;
  color: #212529;
  .ti-item {
    color: #212529;
    > div {
      padding: 6px 10px;
    }
    &.ti-selected-item {
      background-color: $button-blue;
      color: #fff;
    }
  }
}
</style>
